import { render, staticRenderFns } from "./IOSSNumbersEditingSection.vue?vue&type=template&id=56fdd4e8"
import script from "./IOSSNumbersEditingSection.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersEditingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports